import { MDBAlert, MDBBtn, MDBChip, MDBIcon, MDBInput, MDBModalBody, MDBModalFooter } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../../components/CustomSearchUtil/CustomSearch";


// accPools =  available pools in the account
// orgName = Organization name
// existingPools = Already added to the Org group.
export default function EditOrg(props) {


    const [orgExistingAddedPools, setOrgExistingAddedPools] = useState([]);    

    const [allAddedPools, setAllAddedPools] = useState([]);

    const [addedPoolIds, setAddedPoolIds] = useState([]);

    const [sourceAvalPools, setSourceAvalPools] = useState([]);
    const { t } = useTranslation();

    const [searchDestinationByText, setSearchDestinationByText] = useState('');
    const [searchSourceByText, setSearchSourceByText] = useState('');
    
    const [internalError, setInternalError] = useState(false);

    const [addpools, setAddpools] = useState([]);
    const [msg, setMsg] = useState('');
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, true)

    useEffect(() => {
       
        if(props.existingPools && props.accPools && props.orgName){

            let existingPools = props.existingPools?.length > 0 ? [...props.existingPools] : []
            setOrgExistingAddedPools([...existingPools]);
            setAllAddedPools(existingPools);
            props.setOrgName(props.orgName ?? '');
            setSourceAvalPools([...(props.accPools)]);
    
            let arrAddedPoolsId = (existingPools?.reduce((newObj, poolObj) => {
                newObj.push(poolObj.pool_id);
                return newObj ;
            }, [])) ?? [];
            setAddedPoolIds(arrAddedPoolsId);
            console.log("existingPools ::::::::::" , existingPools)
            console.log("allAddedPools 1 ::::::::::" , allAddedPools)
            if(!dataLoaded){
                setDataLoaded(true)
            }
        }

    }, [props]);


    // handling removing of the added pools.

    function handleRemove(poolObj) {
        try {
            // removing from allAddedPools.
            // let addedPools = allAddedPools.filter((Obj) => Obj.pool_id != poolObj.pool_id);
            // setAllAddedPools(addedPools);
            
            let addedPools = addpools.filter((Obj) => Obj.pool_id != poolObj.pool_id);
            setAddpools(addedPools)

            let poolIds = addedPoolIds.filter(poolId => poolId != poolObj.pool_id);
            setAddedPoolIds(poolIds);

        } catch (e) {
            console.log(`unable to remove.${e}`);
        }
    }

    function addHandle(poolObj) {
        try {
            //adding to allAddedPools.
            if (addedPoolIds.includes(poolObj.pool_id)) {
                handleRemove(poolObj);

            } else {
                let poolIds = [...addedPoolIds, poolObj.pool_id];
                setAddedPoolIds(poolIds);

                addpools.push(poolObj);
                setAddpools(addpools)
                // allAddedPools.push(poolObj);
                //let mergingAddedPools = [...allAddedPools, poolObj];
                // setAllAddedPools(allAddedPools);
            }

        } catch (e) {
            console.log(`Unable to add.${e}`);
        }
    }

    function selectAllHandle(e) {
        try {
            e.stopPropagation();
            e.preventDefault();
            // let sourceRemainingPools = [];
            // let sourceRemainingPoolId = [];
            let filteredPools = customSearch(sourceAvalPools, searchDestinationByText, ["pool_name"])

            if (filteredPools.length === 0) {
                return;
            }
            //  preserve already selected items
            let sourceRemainingPoolId = [...addedPoolIds];
            let sourceRemainingPools = [...allAddedPools];
            filteredPools?.forEach((obj)=>{
                if(!addedPoolIds.includes(obj.pool_id)){
                    sourceRemainingPoolId.push(obj.pool_id);
                    sourceRemainingPools.push(obj);
                }
            });
            // sourceRemainingPoolId.push(...addedPoolIds);
            setAddedPoolIds(sourceRemainingPoolId);
            // sourceRemainingPools.push(...allAddedPools);
            setAllAddedPools(sourceRemainingPools);


        } catch (e) {
            console.log(`unable to perform select all:${e}`);
        }


    }

    function save(){
        try{      
            console.log("addpools ::::::::::" , addpools)
            setAddedPoolIds([...addpools]);
            console.log("allAddedPools 2 ::::::::::" , allAddedPools)
            if(!props.orgName || props.orgName.trim().length == 0){
                props.setErrorMessage(`Organization Name cannot be empty`);
                return;
            }  
            const ORG_NAME_REGEX = /^.{1,100}$/;
            if (!ORG_NAME_REGEX.test(props.orgName)) {
                props.setErrorMessage(`The Org Name is invalid. It must not exceed a maximum number of 100 characters.`);
                return;
            }
            let orgExstingPoolIds=[];
            let removeExtOrgPoolJson =  orgExistingAddedPools?.reduce((obj, poolObj)=>{
                if(!addedPoolIds.includes(poolObj.pool_id)){
                    obj[poolObj.pool_id] = poolObj;
                }
                orgExstingPoolIds.push(poolObj.pool_id);
                return obj;
            },{});
            let removedPools = Object.values(removeExtOrgPoolJson ?? {});

            let addedPools= addpools.filter((poolObj=> !(orgExstingPoolIds.includes(poolObj.pool_id)))) ?? [];

            console.log(`Added :${JSON.stringify(addedPools)} : Removed:${JSON.stringify(removedPools)}`);
            if(props.setResOrgInfo ){
                props.setResOrgInfo({
                    added_pools: [...addedPools],
                    removed_pools : [...removedPools],
                    update_org_name : props.orgName
                });
            }
            if(props.setAddOPFlag){
                props.setAddOPFlag(true);
            }

        } catch(error){
            console.log(`Unable to perfrom the save operations...${error}`);
            setInternalError(true);
        }
    }



    return (
        <>

            <div className="add-numbermain mb-3">
                <div class="fw-500">Org Name</div>
                <div className="w-40">
                    <MDBInput maxLength={100} size="sm" disabled = {props.orgName === "Default Org"} value={props.orgName} onChange={(e) => {props.setOrgName(e.target.value); props.setErrorMessage("");}} />
                    {props.errorMessage && (<p className="text-danger">{props.errorMessage}</p>)}
                </div>
            </div>

            <div>
                <div>
                   {/* // Show search only if at least one pool is selected (existing or newly added) */}
                   {(addpools?.length>0 || allAddedPools?.length>0) && (
                    <div className="position-relative mb-3">
                        <div className="form-outline">
                            <input className='form-control' type='text' placeholder='Search'
                                value={searchDestinationByText}
                                onChange={(e) => setSearchDestinationByText(e.target.value)}
                            />
                        </div>
                        <MDBIcon
                            fas
                            icon="search"
                            className="custom-search_icon"
                        />
                    </div>)}



                    <div className="form-group row">
                        <div className="col-12">
                            <div className="form-outlines phoneNumberheight p-0">
                                <div className="chips chips-placeholder">
                                {allAddedPools && allAddedPools.length > 0 || addpools && addpools.length > 0 ? <>
                                    {allAddedPools?.length > 0 && (
                                        // allAddedPools
                                        //     .filter(poolObj => poolObj.pool_name.toLowerCase().includes(searchDestinationByText.toLowerCase()))
                                    
                                        customSearch(allAddedPools, searchDestinationByText, ["pool_name"])
                                            .map((poolObj) => (
                                                <MDBChip
                                                    className="m-chip d-inline py-2 px-3"
                                                    key={poolObj.pool_id}
                                                    >
                                                    {poolObj.pool_name}
                                                </MDBChip>
                                            ))
                                    )}
                                    {addpools?.length > 0 && (
                                    customSearch(addpools, searchDestinationByText, ["pool_name"])
                                    
                                            .map((poolObj) => (
                                                <MDBChip
                                                    onDelete={(e) => handleRemove(poolObj)} className="m-chip d-inline py-2 px-3"
                                                    key={poolObj.pool_id}
                                                    closeIcon size="sm"
                                                    >
                                                    {poolObj.pool_name}
                                                </MDBChip>
                                            ))
                                    )}
                                    </> : <>
                                        <p className='m-1 text-secondary'>
                                            The selected Numbers will appear in this section
                                        </p>
                                    </>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="routing-border p-0 my-4"></div>

                <div className="position-relative">
                    <div className="form-outline">
                        <input className='form-control' type='text' ref={searchRef} placeholder='Search'
                            value={searchSourceByText}
                            onChange={(e) => setSearchSourceByText(e.target.value)} />
                    </div>
                    <MDBIcon
                        fas
                        icon="search"
                        className="custom-search_icon"
                    />
                </div>

                <label className="selectall pt-2 text-primary cursor-pointer " onClick={(e) => selectAllHandle(e)}>
                    {t("selectAll")}
                </label>
                <div className="phoneNumberheight">
                    <div className="routing-numbers">
                        <div className="chips chips-placeholder">
                            {sourceAvalPools && sourceAvalPools.length > 0 && (
                               
                                customSearch(sourceAvalPools, searchSourceByText, ["pool_name"])

                                   .map(poolObj => (
                                        <div
                                            className={addedPoolIds.includes(poolObj.pool_id) ? "numberadd-green" : "numberadd"}
                                            onClick={(e) => { e.stopPropagation(); e.preventDefault(); addHandle(poolObj) }}
                                        >
                                            {poolObj.pool_name}
                                        </div>
                                    ))
                            )}
                        </div>
                    </div>
                </div>
                <MDBModalFooter>
                    <MDBBtn color="secondary" onClick={(e) => {props.setErrorMessage("");props.onClose()}}>
                        {t("close")}
                    </MDBBtn>
                    <MDBBtn onClick={(e) => {e.stopPropagation();e.preventDefault(); save(e)}}>{props.sendText ?? t("save")}</MDBBtn>
                </MDBModalFooter>

            </div>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="top-center"
                delay={5000}
                onClose={() => setInternalError(false)}
            >Internal Server Error</MDBAlert>)}
        </>
    );

}